import { aplicarMascara } from "@/utils/MaskUtils.js";
import { isBlank } from "@/utils/StringUtils.js";

// CNPJ alfanumérico (IN RFB): 12 primeiras posições aceitam letras maiúsculas e números,
// os 2 dígitos verificadores continuam numéricos. Tokens da string-mask: A = [a-zA-Z0-9], 0 = dígito.
export const MASCARA_CNPJ = "AA.AAA.AAA/AAAA-00";

export const formatarCnpj = (cnpj) => {
	if(isBlank(cnpj)){
		return "";
	}
	return aplicarMascara(String(cnpj).toUpperCase(), MASCARA_CNPJ);
};

const PESOS_DIGITO_CNPJ = [6, 5, 4, 3, 2, 9, 8, 7, 6, 5, 4, 3, 2];

const calcularDigitoCnpj = (valorParcial) => {
	let soma = 0;
	for(let indice = 0; indice < valorParcial.length; indice++){
		soma += (valorParcial.charCodeAt(indice) - 48) * PESOS_DIGITO_CNPJ[PESOS_DIGITO_CNPJ.length - valorParcial.length + indice];
	}
	const resto = soma % 11;
	return resto < 2 ? 0 : 11 - resto;
};

// Dígito verificador do CNPJ alfanumérico: cada caractere entra no módulo 11 com o valor
// ASCII - 48 (dígitos valem 0-9, letras maiúsculas valem 17-42); os 2 DVs são sempre numéricos.
// Mesmo algoritmo do CNPJUtil do backend (junta-digital-util).
export const cnpjValido = (cnpj) => {
	if(isBlank(cnpj)){
		return false;
	}
	const valor = String(cnpj).toUpperCase();
	if(!/^[A-Z0-9]{12}[0-9]{2}$/.test(valor)){
		return false;
	}
	if(/^(.)\1{13}$/.test(valor)){
		return false;
	}
	const digito1 = calcularDigitoCnpj(valor.substring(0, 12));
	const digito2 = calcularDigitoCnpj(valor.substring(0, 12) + digito1);
	return valor === `${valor.substring(0, 12)}${digito1}${digito2}`;
};
